import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/store/auth";
import type { ProjectSide } from "@/v2Projects/types";

function asPositiveNumber(value: unknown): number | null {
  const parsed = Number(value);
  if (Number.isFinite(parsed) && parsed > 0) {
    return parsed;
  }
  return null;
}

export function useProjectContext() {
  const route = useRoute();
  const auth = useAuthStore();

  const side = computed<ProjectSide>(() => {
    return route.path.startsWith("/expert") ? "expert" : "client";
  });

  const currentSeId = computed<number>(() => {
    const user = auth.user as Record<string, unknown> | null;
    if (!user) {
      return 1;
    }

    // Prefer Shopexperts user identifier for project membership ownership.
    const seId =
      asPositiveNumber(user.se_user_id) ??
      asPositiveNumber(user.se_id) ??
      asPositiveNumber(user.user_id) ??
      asPositiveNumber(user.id);

    return seId ?? 1;
  });

  return {
    side,
    currentSeId,
  };
}
